import { gql } from "@apollo/client";

export default gql`
  mutation deletePosPurchase($_id: String) {
    deletePosPurchase(_id: $_id) {
      ok
      message
      error
    }
  }
`;
